import DOMPurify from 'dompurify';

const config = {
	ALLOWED_TAGS: [
		'div',
		'p',
		'span',
		'br',
		'h1',
		'h2',
		'h3',
		'strong',
		'b',
		'em',
		'i',
		'u',
		'ul',
		'ol',
		'li',
		'blockquote',
		'a',
	],
	ALLOWED_ATTR: [
		'style',
		'class',
		'href',
		'target',
		'contenteditable',
		'data-user-id',
	],
	ALLOW_DATA_ATTR: true,
};

export const sanitize = dirty => {
	if (!dirty || typeof dirty !== 'string') return dirty;
	return DOMPurify.sanitize(dirty, config);
};

export default sanitize;
